<div class="app-component">
  <app-fixed-top-header
    class="no-print"
    *ngIf="currentOrganization && currentUser"
    [currentUser]="currentUser">
  </app-fixed-top-header>
  <div class="aws-outbreak-banner" *ngIf="awsOutbreakBannerActive">
    <div>
      <h6>Problemas de Instabilidade na Aplicação</h6>
      <p>
        Confirmamos uma falha que afeta a disponibilidade da aplicação para
        alguns usuários. Nossa equipe está em coordenação com a AWS para a
        rápida resolução.
      </p>
    </div>
    <div class="aws-outbreak-banner-actions">
      <a href="https://status.aws.amazon.com" target="_blank"
        >Ver status do AWS</a
      >
      <button class="btn-dismiss" (click)="dismissAwsOutbreakBanner()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <div
    class="main-app-body"
    [ngClass]="{ 'aws-outbreak-banner-active': awsOutbreakBannerActive }">
    <app-evo-navigation-bar
      class="no-print"
      *ngIf="
        currentUser &&
        organizationService.currentOrganization &&
        permissionsLoaded
      ">
    </app-evo-navigation-bar>
    <div
      class="page-content-wrapper"
      [ngClass]="{ 'sidebar-collapse': getSidebarStatus() }">
      <div class="outlet-wrapper">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<app-toasts></app-toasts>

<div class="helper-info" [ngClass]="{ hide: !helpDeskService.showHelpSidebar }">
  <div class="header">
    <span class="">Ajuda</span>

    <i
      class="fas fa-times pointer"
      (click)="helpDeskService.showHelpSidebar = false"></i>
  </div>

  <div class="body">
    <div [innerHTML]="helpDeskService.helperContent"></div>

    <div class="" *ngIf="helpDeskService.showHelpDialog">
      <p>
        <span [innerHTML]="helpDeskService.helpDialogText"></span>

        <a class="text-primary pointer" (click)="openHelpDialog()">
          clicando aqui </a
        >.
      </p>
    </div>
  </div>
</div>

<!--<evo-ai-assistant [username]="currentUser.name"
                  *ngIf="currentUser && aiEnabled"
                  logoPath="/assets/images/logo-evollo.png"
                  [apiUrl]="genAiUrl"
				  [authToken]="currentToken">
</evo-ai-assistant>-->
